import styled, { css, keyframes } from 'styled-components'
import IconCalendar from '../../assets/img/icon-calendar.svg'

const showBottom = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0px, 200px, 0px);
  } to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
`

const showTop = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0px, -200px, 0px);
  } to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
`

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const CalendarWrapper = styled.aside`
  ${({ theme, rightSide }) => css`
    display: flex;
    margin-top: -4px;

    @media (min-width: ${theme.media.desktop}) {
      height: 63px;
    }

    @media (max-width: 424px) {
      flex-direction: column;

      .react-datepicker__input-container {
        max-width: 100%;
      }
    }

    .calendar-start {
      margin-right: 8px;

      @media (max-width: 424px) {
        margin-right: 0;
      }
    }

    input {
      max-width: 124px;

      padding: 12px;
      border: 1px solid #afaeae;
      border-radius: 4px;

      font-family: 'Montserrat';
      font-size: 13px;
      font-weight: 400;
      margin-top: 4px;

      background: url(${IconCalendar}) right 16px center no-repeat;
      background-size: 15px;
      background-color: #fff;

      transition: all 400ms;

      @media (max-width: 500px) {
        width: 100%;
      }

      @media (max-width: 424px) {
        max-width: 100%;
      }

      &::placeholder {
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        color: #afaeae;
      }

      &:focus {
        border-color: ${theme.colors.primary};
      }
    }

    ${!!rightSide &&
    css`
      .react-datepicker-popper {
        z-index: 1000;
        left: -120px !important;

        @media (max-width: 800px) {
          left: -20px !important;
        }
      }

      .react-datepicker-popper[data-placement^='top'] {
        padding-bottom: 0px;

        .react-datepicker {
          font-size: 14px;
          font-family: 'MontSerrat';
          border: 0;
          border-radius: 0;
          filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
          animation: ${showTop} 300ms;
        }
      }
    `}

    .react-datepicker {
      font-size: 14px;
      font-family: 'MontSerrat';
      border: 0;
      border-radius: 0;
      filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
      animation: ${showBottom} 300ms;
    }

    .react-datepicker__portal {
      transition: background 0.2s;
      animation: ${showModal} 200ms;
    }

    //Exibir somente dias do mês vigente
    .react-datepicker__day--outside-month {
      visibility: hidden;
    }

    .react-datepicker__navigation {
      background: none;
      line-height: 1.7rem;
      text-align: center;
      cursor: pointer;
      position: absolute;
      top: 10px;
      width: 0;
      padding: 0;
      border: 0.75rem solid transparent;
      z-index: 1;
      height: 10px;
      width: 10px;
      text-indent: -999em;
      overflow: hidden;
    }

    ${!!rightSide &&
    css`
      .react-datepicker__triangle {
        @media (min-width: 800px) {
          left: 78px !important;
        }
      }
    `}

    .react-datepicker-popper[data-placement^="top"] {
      /* bottom: -2px !important; */
    }

    .react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::before,
    .react-datepicker__year-read-view--down-arrow::before,
    .react-datepicker__month-read-view--down-arrow::before,
    .react-datepicker__month-year-read-view--down-arrow::before {
      bottom: -1px;
      border-top-color: rgba(0, 0, 0, 0.05);
    }

    .react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::after {
      top: 2px;

      border-top: none;
      border-bottom-color: ${theme.colors.primary};
    }

    .react-datepicker__navigation--next {
      border-left-color: white;
    }

    .react-datepicker__navigation--previous {
      border-right-color: white;
    }

    .react-datepicker__month-container {
    }

    .react-datepicker__header {
      text-align: center;
      background-color: ${theme.colors.primary};
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      padding-top: 0px;
      position: relative;
      border: none;
    }

    .react-datepicker__current-month {
      font-size: 16px;
      color: #fff;
      font-weight: 500;
      text-transform: capitalize;
      padding: 8px;
      /* margin-top: -5px; */

      //Tirar cabeçalho mês
      /* display: none; */
    }

    .react-datepicker__day-names {
      padding: 8px;
      display: flex;
      margin-bottom: -12px;
      justify-content: space-around;
      font-weight: 400;
      background-color: #fff;
      text-transform: capitalize;
    }

    .react-datepicker__day-name {
      color: #aab1c2;
      width: 36px;
      display: inline;
    }

    .react-datepicker__month {
      margin: 0 12px;
    }

    .react-datepicker__day {
      font-size: 16px;
      width: 32px;
      height: 32px;
      margin: 4px;
      font-weight: 500;
      line-height: 20px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      transition: ease 100ms;
    }

    .react-datepicker__day--today {
      font-weight: 600;
    }

    .react-datepicker__day--today:focus {
      color: white;
      font-weight: 600;
    }

    .react-datepicker__close-icon::after {
      cursor: pointer;
      background-color: #d22630;
      color: #fff;
      border-radius: 4px;
      height: 20px;
      width: 20px;
      font-size: 15px;
      font-weight: 600;
      right: 0;
      position: absolute;
      top: 15px;
      right: 12px;
    }

    .react-datepicker__day--disabled,
    .react-datepicker__month-text--disabled,
    .react-datepicker__quarter-text--disabled,
    .react-datepicker__year-text--disabled {
      color: #aab1c2;
      background: transparent !important;
      font-weight: 400;
    }

    .react-datepicker__day--disabled:hover,
    .react-datepicker__month-text--disabled:hover,
    .react-datepicker__quarter-text--disabled:hover,
    .react-datepicker__year-text--disabled:hover {
      color: #aab1c2;
      background-color: #fff;
      font-weight: 400;
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--in-selecting-range,
    .react-datepicker__year-text--in-range {
      border-radius: 50%;
      background-color: ${theme.colors.primary};
      color: #fff;
    }

    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected {
      background: ${theme.colors.primary};
      border-radius: 50%;
    }

    .react-datepicker__day:hover,
    .react-datepicker__month-text:hover,
    .react-datepicker__quarter-text:hover,
    .react-datepicker__year-text:hover {
      border-radius: 50%;
    }
  `}
`
